// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as net from 'util/Net';

function adminGet(url, data) {
  if ((window.bootstrap != null ? window.bootstrap.organization_id : undefined) != null) {
    data.organization_id = window.bootstrap.organization_id;
  }
  return net.getJSON(url, data);
}

function adminPost(url, data) {
  if ((window.bootstrap != null ? window.bootstrap.organization_id : undefined) != null) {
    data.organization_id = window.bootstrap.organization_id;
  }
  return net.postJSON({url, data});
}

export {adminGet, adminPost};
